import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconProject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.75 13.6875H14.25C14.4961 13.6875 14.6875 13.4961 14.6875 13.25V6.6875C14.6875 6.44141 14.4961 6.25 14.25 6.25H10.1758C9.68359 6.25 9.24609 6.08594 8.86328 5.8125L7.79688 5.01953C7.74219 4.96484 7.63281 4.9375 7.55078 4.9375H3.75C3.50391 4.9375 3.3125 5.12891 3.3125 5.375V13.25C3.3125 13.4961 3.50391 13.6875 3.75 13.6875ZM14.25 15H3.75C2.79297 15 2 14.207 2 13.25V5.375C2 4.41797 2.79297 3.625 3.75 3.625H7.55078C7.93359 3.625 8.28906 3.76172 8.58984 3.98047L9.65625 4.77344C9.79297 4.88281 9.98438 4.9375 10.1758 4.9375H14.25C15.207 4.9375 16 5.73047 16 6.6875V13.25C16 14.207 15.207 15 14.25 15Z",
		fill: "currentColor"
	})
});
export default SvgIconProject;
